import React, { useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { get, SiteConfigManager, useApplicationState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Icon, Label } from '@atlas/ui';

import ClientProfileRouter from 'components/ClientProfile/ClientProfileRouter';
import { defaultRoutes } from 'components/MainRouter/constants';
import SeoPageText from 'components/SeoPage/SeoPageText';
import useSignInRedirects from 'src/components/Auth/useSignInRedirects';

import ClientProfileNavigation from './ClientProfileNavigation';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { menu } = defaultRoutes;

const ClientProfile = () => {
  const { redirectToSignIn } = useSignInRedirects();
  const page = SiteConfigManager.getComponentOptions(CLIENT_PROFILE);
  const applicationState = useApplicationState();
  const history = useHistory();
  const { authenticated, resolved } = applicationState;

  React.useEffect(() => {
    if (!resolved || authenticated) {
      return;
    }

    const { pathname } = history.location;

    redirectToSignIn({ redirectPath: pathname });
  }, [resolved, authenticated, history, redirectToSignIn]);

  const clientProfileTabs = useMemo(() => get(page, 'tabs', []), [page]);

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  // Check
  return (
    <div className="layout-to-scroll">
      <div className="user-profile">
        <Link className="back-to-container" to={menu}>
          <Icon className="icon-back" name="back" />
          <Label className="title-text" message="my_profile" />
        </Link>
        <ClientProfileNavigation
          clientProfilePath={clientProfilePath}
          clientProfileTabs={clientProfileTabs}
        />
        <ClientProfileRouter
          clientProfilePath={clientProfilePath}
          clientProfileTabs={clientProfileTabs}
        />
      </div>
      <SeoPageText />
    </div>
  );
};

export default ClientProfile;
